'use client';

import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { Typography } from '@/components/ui/typography/typography.component';

interface CartEntityHeaderProps {
  name: string;
  avatar?: string;
  entityType: EntityTypeEnum;
  dataTestId: string;
}

export function CartEntityHeader({ name, avatar, entityType, dataTestId }: CartEntityHeaderProps) {
  return (
    <div className="flex w-full items-center gap-2" data-testid={dataTestId}>
      <EntityAvatar
        type={entityType}
        src={avatar}
        alt={name}
        size="lg"
        width={56}
        height={56}
        className="h-14 w-14 shrink-0 object-cover"
      />

      <Typography className="line-clamp-2 min-w-0 flex-1 text-base font-bold leading-6 text-gray-700">
        {name}
      </Typography>
    </div>
  );
}
